import { render, staticRenderFns } from "./OverlayCircularLoading.vue?vue&type=template&id=0c13753e&"
import script from "./OverlayCircularLoading.vue?vue&type=script&lang=js&"
export * from "./OverlayCircularLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VOverlay})
